var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ListItemIcon, Paper, Toolbar, Typography } from '@mui/material';
import { Edit } from '@mui/icons-material';
import Box from '@mui/material/Box';
export var TituloCardCinza = function (_a) {
    var titulo = _a.titulo, _b = _a.icon, icon = _b === void 0 ? _jsx(Edit, {}) : _b, children = _a.children, onClick = _a.onClick;
    return (_jsxs(Paper, __assign({ sx: { borderRadius: 2, overflow: 'hidden', width: '100%' } }, { children: [_jsxs(Toolbar, __assign({ sx: {
                    backgroundColor: '#737373',
                    color: '#ffffff',
                    position: 'relative',
                    minHeight: '64px',
                    px: 2,
                } }, { children: [_jsx(ListItemIcon, __assign({ sx: {
                            position: 'absolute',
                            left: 16,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#ffffff',
                            fontSize: '32px',
                            zIndex: 10,
                            cursor: 'pointer',
                            minWidth: 'unset',
                        }, onClick: onClick }, { children: icon })), _jsx(Typography, __assign({ variant: "h6", component: "div", sx: {
                            width: '100%',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        } }, { children: titulo }))] })), _jsx(Box, __assign({ sx: { p: 2 } }, { children: children }))] })));
};
